import React, { useRef, useState } from 'react';
import { ThemeProvider } from '@amzn/storm-ui';
import { SIDEBAR_TYPE, ToolbarItem } from '@amzn/aac-chrome-internal-api';
import { ToolbarItemProps } from '../../store/slice';
import {
  MobileDivider,
  MobileSideNavItemText,
  MoreToolsMenuItem,
  NonExpandableItemLink,
} from './styles';
import ExpandableMenuItem from './ExpandableMenuItem';
import MoreToolsView from './MoreToolsView';
import { overrideModalZIndex } from 'src/commons/utils/helpers';
import { MobileNavSheet } from './MobileNavSheet';
import { MOBILE_MENU_SUB_MENU_Z_INDEX } from 'src/commons/constants';
import { renderFlag } from 'src/commons/utils/renderFlag';

const MobileSideNavItem: React.VFC<ToolbarItem> = (
  sideNavItem: ToolbarItem,
) => {
  const moreToolsRef = useRef(null);
  const [isMoreToolsOpen, setIsMoreToolsOpen] = useState(false);
  if (sideNavItem.sidebarType == SIDEBAR_TYPE.DIVIDER) {
    return <MobileDivider />;
  }
  if (!sideNavItem.sidebarGroups) {
    return null;
  }
  const item = sideNavItem as ToolbarItemProps;
  if (item.sidebarType == SIDEBAR_TYPE.TOOL) {
    return (
      <ThemeProvider theme={overrideModalZIndex(MOBILE_MENU_SUB_MENU_Z_INDEX)}>
        <MoreToolsMenuItem
          ref={moreToolsRef}
          onClick={() => setIsMoreToolsOpen(true)}
        >
          <img src={item.iconPath} alt={item.toolTip} />
          {item.toolTip}
        </MoreToolsMenuItem>
        <MobileNavSheet
          isOpen={isMoreToolsOpen}
          onClose={() => setIsMoreToolsOpen(false)}
          closeButton={{
            type: 'icon',
            label: 'close',
          }}
          type="dark"
          side="start"
        >
          <MoreToolsView {...item} />
        </MobileNavSheet>
      </ThemeProvider>
    );
  } else if (
    item.sidebarGroups.length == 1 &&
    item.sidebarGroups[0].links.length == 1
  ) {
    return (
      <NonExpandableItemLink
        href={item.sidebarGroups[0].links[0].link.url}
        data-takt-id={item.sidebarGroups[0].links[0].id}
        isSelected={item.sidebarGroups[0].links[0].isSelected}
      >
        <img src={item.iconPath} alt={item.toolTip} />
        <MobileSideNavItemText>
          {item.sidebarGroups[0].links[0].link.label}
          {renderFlag(item.sidebarGroups[0].links[0], {
            isMobile: true,
            isInverted: true,
          })}
        </MobileSideNavItemText>
      </NonExpandableItemLink>
    );
  } else {
    return <ExpandableMenuItem {...item} />;
  }
};

export default MobileSideNavItem;
